// client/src/layouts/AppLayout.jsx

import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Header from '../components/common/Header';
import { useCallContext } from '../contexts/CallContext';
import { useTokenValidator } from '../hooks/useTokenValidator'; // ← NEW
import AppHeader from '../components/common/V4Header/AppBarV4'; // ← NEW
const SMSApp = lazy(() => import('../components/SMS/SMSApp'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center p-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

export default function AppLayout() {
  const {
    isAuthenticated, isAuthLoading, currentUser,
    connectionStatus, getStatusColor, getStatusText,
    handleLogout, reconnectAttempts, MAX_RECONNECT_ATTEMPTS,
    connectWebSocket, handleManualSearch, isSearching,
    appConfig, isSMSOpen, smsContact, smsDraft, closeSMS, audioRef,
  } = useCallContext();

  // ─── NEW: Validate token on focus/visibility/idle ───
  useTokenValidator(isAuthenticated);

  if (isAuthLoading) {
    return (
      <div className="flex items-center justify-center p-8 min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <div className="app pt-16">
      {isSMSOpen && (
        <Suspense fallback={null}>
          <SMSApp initialContact={smsContact} initialMessage={smsDraft} onClose={closeSMS} />
        </Suspense>
      )}

      {/* <Header
        currentUser={currentUser}
        connectionStatus={connectionStatus}
        getStatusColor={getStatusColor}
        getStatusText={getStatusText}
        handleLogout={handleLogout}
        reconnectAttempts={reconnectAttempts}
        MAX_RECONNECT_ATTEMPTS={MAX_RECONNECT_ATTEMPTS}
        connectWebSocket={connectWebSocket}
        onSearch={handleManualSearch}
        isSearching={isSearching}
        searchEnabled={appConfig.features.searchEnabled}
      /> */}
      <AppHeader
        currentUser={currentUser}
        connectionStatus={connectionStatus}
        getStatusColor={getStatusColor}
        getStatusText={getStatusText}
        handleLogout={handleLogout}
        reconnectAttempts={reconnectAttempts}
        MAX_RECONNECT_ATTEMPTS={MAX_RECONNECT_ATTEMPTS}
        connectWebSocket={connectWebSocket}
        onSearch={handleManualSearch}
        isSearching={isSearching}
        searchEnabled={appConfig.features.searchEnabled}
      />
      <audio ref={audioRef} src="/notification.mp3" preload="auto" />

      <Outlet />
    </div>
  );
}